import { Grid, makeStyles } from '@material-ui/core';
import React, { useEffect, useMemo } from 'react';
import EventFieldDescription from './EventFieldDescription';
import {
    constructEventDateTimeString,
    eighthCol,
    fifthCol,
    fifthColRequired,
    firstCol,
    fourthCol,
    ninthCol,
    secondCol,
    seventhCol,
    sixthCol,
    sixthColRequired,
    tenthCol,
    thirdCol,
} from '../../FormUtils';
import EventFieldMap from './EventFieldMap';

const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: '24px',
        fontWeight: '500',
    },
    container: {
        lineHeight: '196%',
    },
}));

const EventDetailDescription = ({ eventData }) => {
    const classes = useStyles();

    const eventIsAllowParticipate = useMemo(() => {
        const arr = [];
        if (eventData.internalCapacity > 0) {
            arr.push('พนักงานและลูกจ้างพนักงาน');
        }
        if (eventData.externalCapacity > 0) {
            arr.push('บุคคลภายนอก');
        }
        if (
            eventData.internalCapacity === null &&
            eventData.externalCapacity === null &&
            eventData.isPublic
        ) {
            arr.push('พนักงานและลูกจ้างพนักงาน', 'บุคคลภายนอก');
        }
        return arr;
    }, [eventData]);

    const isPublic = useMemo(() => {
        return eventData.isPublic;
    }, [eventData]);

    const isRequiredCheckin = useMemo(() => {
        return eventData.isRequiredCheckin;
    }, [eventData]);

    const fieldOrder = useMemo(() => {
        const hasCapacity =
            eventData.internalCapacity !== null ||
            eventData.externalCapacity !== null;
        const noCapacity =
            eventData.internalCapacity == null &&
            eventData.externalCapacity == null;
        if (isPublic && noCapacity && isRequiredCheckin) {
            return [firstCol, secondCol];
        }

        if (isPublic && noCapacity && !isRequiredCheckin) {
            return [thirdCol, fourthCol];
        }

        if (isPublic && hasCapacity && !isRequiredCheckin) {
            return [fifthCol, sixthCol];
        }

        if (isPublic && hasCapacity && isRequiredCheckin) {
            return [fifthColRequired, sixthColRequired];
        }

        if (noCapacity) {
            return [seventhCol, eighthCol];
        }

        if (isRequiredCheckin) {
            return [ninthCol, tenthCol];
        }

        return [firstCol, secondCol];
    }, [isPublic, isRequiredCheckin, eventData]);

    return (
        <div className={classes.container}>
            <div className={classes.title}>รายละเอียดกิจกรรม</div>
            <Grid container>
                <Grid item xs={12}>
                    <EventFieldDescription
                        fieldName="ชื่อกิจกรรม"
                        value={eventData.eventName ? eventData.eventName : '-'}
                    />
                </Grid>
                <Grid item xs={12}>
                    <EventFieldDescription
                        fieldName="รายละเอียดกิจกรรม"
                        value={eventData.eventDescription}
                        isHtml={true}
                    />
                </Grid>
                <Grid item xs={12}>
                    <EventFieldDescription
                        fieldName="ข้อมูลวิทยากร"
                        value={eventData.speakers}
                        isHtml={true}
                    />
                </Grid>
                <Grid item sm={12}>
                    <Grid container>
                        <Grid item sm={12} lg={6}>
                            <EventFieldDescription
                                fieldName="สถานที่จัดกิจกรรม"
                                value={eventData.venue ? eventData.venue : '-'}
                            />
                            <EventFieldDescription
                                fieldName="วันที่เริ่มกิจกรรม"
                                value={
                                    eventData.eventStartDate
                                        ? constructEventDateTimeString(
                                              eventData.eventStartDate,
                                              eventData.eventStartTime
                                          )
                                        : '-'
                                }
                            />
                            <EventFieldDescription
                                fieldName="วันที่สิ้นสุดกิจกรรม"
                                value={
                                    eventData.eventEndDate
                                        ? constructEventDateTimeString(
                                              eventData.eventEndDate,
                                              eventData.eventEndTime
                                          )
                                        : '-'
                                }
                            />
                            {/* first column layout */}
                            {fieldOrder &&
                                fieldOrder[0] &&
                                fieldOrder[0].map((value) => {
                                    return (
                                        <EventFieldMap
                                            fieldName={value}
                                            eventData={eventData}
                                            eventIsAllowParticipate={
                                                eventIsAllowParticipate
                                            }
                                            key={value}
                                        />
                                    );
                                })}
                        </Grid>
                        <Grid item sm={12} lg={6}>
                            <EventFieldDescription
                                fieldName="ผู้ประสานงานหลัก"
                                value={
                                    eventData.mainCoordinator
                                        ? eventData.mainCoordinator.fullName
                                        : '-'
                                }
                            />
                            <EventFieldDescription
                                fieldName="ผู้ช่วยจัดกิจกรรม"
                                value={
                                    Array.isArray(eventData.coordinators) &&
                                    eventData.coordinators.length > 0
                                        ? eventData.coordinators
                                              .map((coord) => coord.fullName)
                                              .join(', ')
                                        : '-'
                                }
                            />
                            <EventFieldDescription
                                fieldName="การเผยแพร่กิจกรรม"
                                value={
                                    eventData.isPublic
                                        ? 'เปิดเผยสาธารณะ'
                                        : 'เฉพาะผู้จัดกิจกรรม/ตามรายชื่อที่กำหนด'
                                }
                            />
                            {/* second column layout */}
                            {fieldOrder &&
                                fieldOrder[1] &&
                                fieldOrder[1].map((value) => {
                                    return (
                                        <EventFieldMap
                                            fieldName={value}
                                            eventData={eventData}
                                            eventIsAllowParticipate={
                                                eventIsAllowParticipate
                                            }
                                            key={value}
                                        />
                                    );
                                })}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

export default EventDetailDescription;
